const Flickity = require('flickity');
const sliders = document.querySelectorAll('.jsSlider');

if (sliders) {

	sliders.forEach( (item) => {
		const sliderPrev = item.parentElement.querySelector('.sliderPrev');
		const sliderNext = item.parentElement.querySelector('.sliderNext');

		let flkty = new Flickity( item, {
			accessibility: true,
			prevNextButtons: false,
			pageDots: false,
			imagesLoaded: true,
			autoPlay: 5000,
			pauseAutoPlayOnHover: true,
			on: {
				ready: function() {
					setTimeout( () => {
						setSliderHeightToMax(this);
					}, 100);
				}
			}
		})

		flktyFunctions(flkty);

		function setSliderHeightToMax(slider) {
			slider.cells.forEach(cell => cell.element.style.height = '');

			let heights = slider.cells.map(cell => cell.element.offsetHeight),
				max = Math.max.apply(Math, heights);

			slider.cells.forEach(cell => cell.element.style.height = max + 'px');
		}

		function flktyFunctions(flkty) {
			sliderPrev.addEventListener('click', () => {
				flkty.previous();
			});

			sliderNext.addEventListener('click', () => {
				flkty.next();
			});

			window.addEventListener('resize', () => {
				setSliderHeightToMax(flkty);

				setTimeout( () => {
					flkty.resize();
				}, 300);
			});

			window.addEventListener('load', () => {
				setSliderHeightToMax(flkty);

				setTimeout( () => {
					flkty.resize();
				}, 300);
			});
		}
	})
}
